import { render, staticRenderFns } from "./ClientFilterContent.vue?vue&type=template&id=684964e4&scoped=true"
import script from "./ClientFilterContent.vue?vue&type=script&lang=js"
export * from "./ClientFilterContent.vue?vue&type=script&lang=js"
import style0 from "./ClientFilterContent.vue?vue&type=style&index=0&id=684964e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684964e4",
  null
  
)

export default component.exports